import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styles from './PromoCard.module.scss';
import VectorIcon from '@/assets/icons/vector.svg?react';
import ChevronRight from '@/assets/icons/chevron-right.svg?react';
import { PROMO } from '@/Router/routes';
import Button from '@/components/Button/Button';

const PromoCard = memo(() => {
  const navigate = useNavigate();
  const { t } = useTranslation('promo');

  return (
    <Button
      onClick={() => navigate(PROMO)}
      dataTest="promo-card"
      buttonClassName={styles.cardWrapper}
      disableStyles
    >
      <div className={styles.promoTitle} data-test="promo-title">
        {t('title')}
      </div>
      <div className={styles.promoContainer}>
        <div className={styles.promoText}>
          <VectorIcon data-test="promo-icon" />
          {t('text')}
        </div>
        <ChevronRight
          className={styles.chevron}
          height={12}
          data-test="promo-chevron-right-icon"
        />
      </div>
    </Button>
  );
});

export default PromoCard;
